// Import Modules
import { Cart } from "./modules/Cart";
import { Money } from "./modules/Money";

// Import Components
import toggleVisibility from "./components/toggle-visibility/main";
// import exampleComponent from "./components/example-component/main";
import productCards from "./components/product-card/main";
import quickAddPopup from "./components/quick-add-popup/main";
import filterPopup from "./components/filter-popup/main";

// Import Sections
// import exampleSection from "./sections/example-section/main";
import header from "./sections/header/main";
import announcementBanner from "./sections/announcement-banner/main";
import hero from "./sections/hero/main";
import faqsSection from "./sections/faqs/main";
import featuredArticles from "./sections/featured-articles/main";
import featuredAuthors from "./sections/featured-authors/main";
import featuredCollections from "./sections/featured-collections/main";
import featuredCollection from "./sections/featured-collection/main";
import featuredProducts from "./sections/featured-products/main";
import featuredReviews from "./sections/featured-reviews/main";
import socials from "./sections/socials/main";
import locations from "./sections/locations/main";
import account from "./sections/account/main";
import usps from "./sections/usps/main";
import blogSection from "./sections/blog/main";
import collectionTemplate from "./sections/collection-template/main";
import stories from "./sections/stories/main";
import collectionFaqs from "./sections/collection-faqs/main";
import subscriptionPopular from "./sections/subscription-popular/main";
import SubscriptionPoints from "./sections/subscription-points/main";
import subscriptionListVideo from "./sections/subscription-list-video/main";
import subscriptionReviews from "./sections/subscription-reviews/main";
import subscriptionAccordions from "./sections/subscription-accordions/main";
import footer from "./sections/footer/main";
import accordion from "./sections/accordion/main";
import articleLinks from "./sections/article-links/main";
import iconsSldier from "./sections/icons-slider/main";
import searchTemplate from "./sections/search-template/main";
import tribeSiteHeader from "./sections/tribe-site-header/main";
import articleMetaobjects from "./sections/article-metaobjects/main";
import anchorLinks from "./sections/anchor-links/main";
import loyaltyLion from "./sections/loyaltylion/main";
import productEquipmentCloserLook from "./sections/product-equipment-closer-look/main";
import productEquipmentSpecs from "./sections/product-equipment-spec/main";

//Accounts
import tribeAccountLogin from "./sections/tribe-account-login/main";
import tribeAccount from "./sections/tribe-account/main";
import TribeAccountAddresses from "./sections/tribe-account-addresses/main";

// Import Product Sections
import productTemplate from "./sections/product-template/main";
import productSnapshot from "./sections/product-snapshot/main";
import productGallery from "./sections/product-gallery/main";
import productFaqsSection from "./sections/product-faqs/main";

//Import Cart Sections
import cartTemplate from "./sections/cart-template/main";
import cartAside from "./sections/cart-aside/main";

//Import Cookie Banner
import cookieBanner from "./sections/cookie-banner/main";

//Import Article Sections
import articleFooter from "./sections/article-footer/main";

//Import Quiz Sections
import quizMain from "./sections/quiz-main/main";
import quizResults from "./sections/quiz-results/main";

//Import Locations Sections
import pageLocationsCafe from "./sections/page-locations-cafe/main";

document.addEventListener("DOMContentLoaded", (event) => {
  // Add Modules to window
  window.Carbon = { Cart: new Cart(), Money: new Money() };

  // Run Componenets
  // exampleComponent();
  productCards();

  // Run sections
  // exampleSection();
  header();
  announcementBanner();
  hero();
  faqsSection();
  featuredArticles();
  featuredAuthors();
  featuredCollections();
  featuredCollection();
  featuredProducts();
  featuredReviews();
  socials();
  locations();
  account();
  toggleVisibility();
  usps();
  blogSection();
  collectionTemplate();
  stories();
  cartTemplate();
  cartAside();
  cookieBanner();
  collectionFaqs();
  subscriptionPopular();
  SubscriptionPoints();
  subscriptionListVideo();
  subscriptionReviews();
  subscriptionAccordions();
  footer();
  accordion();
  articleLinks();
  iconsSldier();
  searchTemplate();
  tribeSiteHeader();
  articleMetaobjects();
  quickAddPopup();
  filterPopup();
  anchorLinks();
  loyaltyLion();
  productEquipmentCloserLook();
  productEquipmentSpecs();

  // Products
  productTemplate();
  productSnapshot();
  productGallery();
  productFaqsSection();

  //Accounts
  tribeAccount();
  tribeAccountLogin();
  TribeAccountAddresses();

  //Articles
  articleFooter();

  //Quiz Sections
  quizMain();
  quizResults();

  //Locations Sections
  pageLocationsCafe();

  // This snippit is used to counteract the problem on iOS with the 100vh bug
  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };

  const heroHeight = () => {
    const doc = document.documentElement;

    let elementsHeight = 0;
    const $elements = document.querySelectorAll(
      "section.usp-banner, section.anouncement-banner,header.header .localization-selector, header.header .navbar"
    );

    $elements.forEach(($element) => {
      const boundingRect = $element.getBoundingClientRect();
      elementsHeight = elementsHeight + boundingRect.height;
    });
    let total = window.innerHeight - elementsHeight;
    doc.style.setProperty("--hero-height", `${total}px`);
  };

  const headerHeight = () => {
    const doc = document.documentElement;
    const $header = document.querySelector("header.header");
    const total = $header ? $header.getBoundingClientRect().height : 0;
    doc.style.setProperty("--header-height", `${total}px`);
  };

  window.addEventListener("resize", () => {
    appHeight();
    heroHeight();
    headerHeight();
  });
  appHeight();
  heroHeight();
  headerHeight();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const gtmReactivate = urlParams.get("gtm-reactivate");
  if (gtmReactivate == "true") {
    sessionStorage.setItem("gtm-reactivate", "true");
  }
});
